import type { ScLinkField } from '@core/jss-models';
import type {
  HomeBatteryFunnelSettingsInterface,
  HomeBatteryFunnelStep,
} from '@innogy/feh/models';
import { createAction, props } from '@ngrx/store';

const PREFIX = '[HomeBattery Funnel]';

export const initializeHomeBatteryFunnelStepAction = createAction(
  `${PREFIX} Step initialized`,
  props<{
    step: HomeBatteryFunnelStep;
    funnelSettings: HomeBatteryFunnelSettingsInterface | undefined;
  }>()
);

export const setHomeBatteryFunnelInitializedAction = createAction(
  `${PREFIX} Initialize funnel`,
  props<{
    funnelSettings: HomeBatteryFunnelSettingsInterface;
  }>()
);

export const clearHomeBatteryFunnelInitializedAction = createAction(
  `${PREFIX} Reset funnel initialization`
);

export const onHomeBatteryFunnelNavigationAction = createAction(
  `${PREFIX} Navigate`,
  props<{ page: ScLinkField | undefined }>()
);

export const handleHomeBatteryFunnelPrivateErrorAction = createAction(
  `${PREFIX} Private Error`,
  props<{ message: string }>()
);

export const handleHomeBatteryFunnelGenericErrorAction = createAction(
  `${PREFIX} Generic Error`
);

export const mintHomeBatteryTrackingIdAction = createAction(
  `${PREFIX} Mint E2E tracking ID`,
  props<{
    id: string;
  }>()
);

export const navigateToOrderFormPageAction = createAction(
  `${PREFIX} Navigate to order form page`,
  props<{ pageData?: ScLinkField }>()
);

export const navigateToQuestionairePageAction = createAction(
  `${PREFIX} Navigate to questionnaire page`,
  props<{ pageData?: ScLinkField }>()
);

export const navigateToStartPageAction = createAction(
  `${PREFIX} Navigate to start form page`,
  props<{ pageData?: ScLinkField }>()
);
